"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _filterDOMProps = _interopRequireDefault(require("../../utils/filterDOMProps"));

var _react = _interopRequireWildcard(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var MenuHeading =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuHeading, _Component);

  function MenuHeading() {
    (0, _classCallCheck2["default"])(this, MenuHeading);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuHeading).apply(this, arguments));
  }

  (0, _createClass2["default"])(MenuHeading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          children = _this$props.children,
          _this$props$role = _this$props.role,
          role = _this$props$role === void 0 ? 'presentation' : _this$props$role,
          ariaLevel = _this$props['aria-level'],
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["label", "children", "role", "aria-level"]);
      return _react["default"].createElement("li", (0, _extends2["default"])({
        role: role,
        className: "spectrum-Menu-sectionHeading"
      }, (0, _filterDOMProps["default"])(otherProps)), _react["default"].createElement("span", {
        role: "heading",
        "aria-level": ariaLevel || 3
      }, label || children));
    }
  }]);
  return MenuHeading;
}(_react.Component);

exports["default"] = MenuHeading;
(0, _defineProperty2["default"])(MenuHeading, "displayName", 'MenuHeading');